import React, { forwardRef, useEffect } from "react";

import SearchBox from './SearchBox.jsx'
import { translate } from "../../../utility/strings.js";

const SearchBar = forwardRef((props, ref) => {

  // optional - merchant can blank out the section's heading/subheading
  // settings in the theme editor to hide this entirely.
  const heading = translate("dealer_locator.heading", "");
  const subheading = translate("dealer_locator.subheading", "");

  return (
    <div className="ft_dealer-locator__results__search-bar" ref={ref}>
      <div className="ft_dealer-locator__container">
        {(heading || subheading) ? (
          <div className="prose ft_dealer-locator__results__search-bar__heading">
            {heading ? <h2 className="h4">{heading}</h2> : null}
            {subheading ? <p className="body">{subheading}</p> : null}
          </div>
        ) : null}
        <div className="ft_dealer-locator__results__search-bar__top">
          <SearchBox />
        </div>
      </div>
    </div>
  );

});

export default SearchBar;

